import React, { useEffect } from "react";

// JSON-LD structured data injector. Renders a <script type="application/ld+json">
// into <head> on mount and removes it on unmount, so per-route schema is
// isolated and Google sees route-specific schema even in a SPA.
export default function JsonLd({ data, id }) {
  useEffect(() => {
    const scriptId = `ld-${id || "default"}`;
    let el = document.getElementById(scriptId);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = scriptId;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const existing = document.getElementById(scriptId);
      if (existing) existing.remove();
    };
  }, [data, id]);
  return null;
}
